import Stages from "../../stages/signup/index";
import { Actions } from "../Context";

const getStageById = (id) => {
  return Stages.filter((stage) => {
    return stage.id === id;
  })[0];
};

const getDirection = (currentStage, nextStage) => {
  return Stages.indexOf(currentStage) < Stages.indexOf(nextStage) ? "next" : "prev";
};

const getNextStage = (currentStage, toStage, skipHistory) => {
  // console.log("stageHistory before", stageHistory);
  if (!skipHistory) {
    stageHistory.push(currentStage.id);
    // console.log("stageHistory after", stageHistory);
  }
  const nextStage = getStageById(toStage);
  return {
    currentStage: nextStage,
    direction: getDirection(currentStage, nextStage),
  };
};

//keep a reference to the previous stage, useful to go back to it
let stageHistory = [];

export default (state, action) => {
  // console.log("got action", action);
  switch (action.type) {
    case Actions.GOT_STATUS:
      return {
        far: action.payload.far,
        ...state,
      };
    case Actions.PREV_STAGE:
      return {
        ...state,
        ...getNextStage(state.currentStage, stageHistory.pop(), true),
      };
    case Actions.TO_STAGE:
      return {
        ...state,
        ...getNextStage(state.currentStage, action.payload.toStage),
      };
    case Actions.SELECTED_TEAM_ADMIN:
      return {
        ...state,
        teamMemberMode: false,
        ...getNextStage(state.currentStage, action.payload.toStage),
      };
    case Actions.SELECTED_TEAM_MEMBER:
      return {
        ...state,
        teamMemberMode: true,
        ...getNextStage(state.currentStage, action.payload.toStage),
      };
    case Actions.RECEIVED_STORED_USER_DETAILS:
      return {
        ...state,
        user: action.payload.user,
        sid: action.payload.sid,
      };
    case Actions.UPDATED_USER_DETAILS:
      return {
        ...state,
        user: action.payload.user,
        ...getNextStage(state.currentStage, state.teamMemberMode && !state.far ? "team-search" : "team-location"),
      };
    case Actions.SELECTED_LOCATION:
      const isFtMode = (action.payload.location.AdminCode === "ENG" || action.payload.location.AdminName === "England") && !state.far;
      return {
        ...state,
        location: action.payload.location,
        isFtMode,
        ...getNextStage(state.currentStage, isFtMode ? "team-search" : "team-entry"),
        hideHeader: false,
      };
    case Actions.SEARCHED_FOR_TEAM_NAME:
      return {
        ...state,
        // teamSearchTerm: action.payload.teamName,
        hideHeader: true,
      };
    case Actions.SEARCHED_FOR_LOCATION_NAME:
      return {
        ...state,
        // locationSearchTerm: action.payload.locationName,
        hideHeader: true,
      };
    case Actions.SELECTED_TEAM_NOT_LISTED:
      return {
        ...state,
        ...getNextStage(state.currentStage, "team-entry"),
        hideHeader: false,
      };
    case Actions.SELECTED_TEAM:
      return {
        ...state,
        team: action.payload.team,
        ...getNextStage(state.currentStage, "confirm-details"),
        hideHeader: false,
      };
    case Actions.ADDED_TEAM:
      return {
        ...state,
        team: { TeamName: action.payload.teamName },
        ...getNextStage(state.currentStage, "confirm-details"),
      };
    case Actions.COMPLETED_SIGNUP:
      console.log("COMPLETED SIGNUP", state);
      if (state.teamMemberMode) {
        return {
          ...state,
          ...getNextStage(state.currentStage, "signup-complete"),
        };
      }
      return {
        ...state,
      };
    case Actions.CANCELLED_SIGNUP:
      return {
        ...state,
      };
    default:
      return { ...state };
  }
};
